const types = {
  // Loading states
  SET_FUNNELS_LOADING: 'SET_FUNNELS_LOADING',
  SET_FUNNELS_CREATING: 'SET_FUNNELS_CREATING',
  SET_FUNNELS_UPDATING: 'SET_FUNNELS_UPDATING',
  SET_FUNNELS_DELETING: 'SET_FUNNELS_DELETING',

  // Data mutations
  SET_FUNNELS: 'SET_FUNNELS',
  SET_FUNNEL: 'SET_FUNNEL',
  DELETE_FUNNEL: 'DELETE_FUNNEL',
  UPDATE_FUNNEL: 'UPDATE_FUNNEL',

  // Selection
  SET_SELECTED_FUNNEL: 'SET_SELECTED_FUNNEL',

  // Templates
  SET_FUNNEL_TEMPLATES: 'SET_FUNNEL_TEMPLATES',

  // Stages
  UPDATE_FUNNEL_STAGES: 'UPDATE_FUNNEL_STAGES',
  ADD_FUNNEL_STAGE: 'ADD_FUNNEL_STAGE',
  REMOVE_FUNNEL_STAGE: 'REMOVE_FUNNEL_STAGE',
  UPDATE_FUNNEL_STAGE: 'UPDATE_FUNNEL_STAGE',
};

export default types;
